import React from 'react';
import AddEditUserForm from 'ui-component/AddEditUserForm';

function EditUser() {
  return (
    <div>
      <AddEditUserForm title="Edit User" />
    </div>
  );
}

export default EditUser;
